import Number from "./Number"

export default class Integer extends Number {
  constructor() {
    super()

    this.format = `Integer`
  }
}
